import type { PasskeyLoginOptionsRequest } from '../models/PasskeyLoginOptionsRequest';
import type { PasskeyLoginOptionsResponse } from '../models/PasskeyLoginOptionsResponse';
import type { PasskeyRegisterOptionsResponse } from '../models/PasskeyRegisterOptionsResponse';
import type { PasskeyRegisterVerifyRequest } from '../models/PasskeyRegisterVerifyRequest';
import type { PasskeyStatusResponse } from '../models/PasskeyStatusResponse';
import type { PasskeyVerifyRequest } from '../models/PasskeyVerifyRequest';
import type { Token } from '../models/Token';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type TDataResetPasskeyForUserApiV1PasskeyUserUsernameDelete = {
	username: string;
};

export class PasskeyService {

	public static passkeyStatusApiV1PasskeyStatusGet(): CancelablePromise<PasskeyStatusResponse> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/passkey/status',
		});
	}

	public static passkeyLoginOptionsApiV1PasskeyLoginOptionsPost(
		requestBody: PasskeyLoginOptionsRequest,
	): CancelablePromise<PasskeyLoginOptionsResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/passkey/login/options',
			body: requestBody,
			mediaType: 'application/json',
		});
	}

	public static passkeyLoginVerifyApiV1PasskeyLoginVerifyPost(
		requestBody: PasskeyVerifyRequest,
	): CancelablePromise<Token> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/passkey/login/verify',
			body: requestBody,
			mediaType: 'application/json',
		});
	}

	public static passkeyRegisterOptionsApiV1PasskeyRegisterOptionsPost(): CancelablePromise<PasskeyRegisterOptionsResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/passkey/register/options',
		});
	}

	public static passkeyRegisterVerifyApiV1PasskeyRegisterVerifyPost(
		requestBody: PasskeyRegisterVerifyRequest,
	): CancelablePromise<PasskeyStatusResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/passkey/register/verify',
			body: requestBody,
			mediaType: 'application/json',
		});
	}

	public static passkeyDeleteApiV1PasskeyDelete(): CancelablePromise<PasskeyStatusResponse> {
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/passkey',
		});
	}

	public static resetPasskeyForUserApiV1PasskeyUserUsernameDelete(
		data: TDataResetPasskeyForUserApiV1PasskeyUserUsernameDelete,
	): CancelablePromise<PasskeyStatusResponse> {
		const { username } = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/passkey/user/{username}',
			path: { username },
		});
	}
}
